import { searchRegistry } from "../../platform/search/register/search-registry";
import { UserRoundPlus, FileUser, CircleUserRound } from "lucide-react";

searchRegistry.register([
    {
        id: "users.list",
        title: "User Management",
        description: "Manage application users",
        route: "/user/list",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["users", "list", "admin", "user search"],
        type: 'quickLink',
        priority: 2,
        icon: FileUser
    },
    {
        id: "users.create",
        title: "Create User",
        description: "Create application users",
        route: "/user/create",
        category: "Administration",
        permissions: ["ADMIN"],
        tags: ["users", "accounts", "create"],
        icon: UserRoundPlus
    },
    {
        id: "users.profile",
        title: "Visit Profile",
        description: "view and edit profile",
        route: "/my-profile",
        category: "User Administration",
        permissions: ["USER", "EMPLOYEE"],
        tags: ["profile", "edit profile", "view profile"],
        type: 'quickLink',
        priority: 1,
        icon: CircleUserRound
    },
]);
